module.exports = __webpack_public_path__ + "static/media/2.d5e2bef9.PNG";